module.exports = __webpack_public_path__ + "img/allfones.39be68be.png";